<template>
    <div class="painel-component">
        <div class="icon-painel">
            <i :class="items.icon + ' icon'"></i>
        </div>

        <h2>{{ items.title }}</h2>

        <div class="painelContent">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "PainelComponent",

    props: {
        items: {
            "required": false,
            "type": Object,
            "default": []
        },
    },
}
</script>

<style scoped>
.painel-component {
    padding: 2%;
    position: relative;
    margin: 5% 2% 5% 2%;
    background-color: #ffffff;
    box-shadow: 10px 10px 23px 0 rgba(204, 204, 204, 1);
    -moz-box-shadow: 10px 10px 23px 0 rgba(204, 204, 204, 1);
    -webkit-box-shadow: 10px 10px 23px 0 rgba(204, 204, 204, 1);
}

.painel-component .icon-painel {
    top: -40px;
    width: 80px;
    height: 80px;
    position: absolute;
    padding: 15px 20px;
    background-color: #000000;

}

.painel-component h2 {
    top: -19px;
    left: 100px;
    color: #000;
    font-size: 20px;
    font-weight: 50;
    width: fit-content;
    position: relative;
}

.painel-component .icon-painel i {
    color: white;
    display: block;
    font-size: 35px;
    margin-left: auto;
    margin-right: auto;
}

.painel-component .painelContent {
    clear: both;
}

@media (max-width: 991px) {
    .painel-component .icon-painel {
        top: -20px;
        width: 50px;
        height: 50px;
        padding: 10px 15px;
    }

    .painel-component h2 {
        top: 0;
        left: 60px;
        font-size: 16px;
    }

    .painel-component .icon-painel i {
        font-size: 20px;
    }
}

@media (max-width: 776px) {
    .painel-component {
        margin-top: 10%;
    }
}
</style>